/* Uses the same TagadaClient funnel navigation as the installed checkout mapper. */
(() => {
  const waitForClient = async () => {
    const deadline = Date.now() + 15000;
    do {
      const client = window.TgdMapper?.tagadaClient;
      if (client?.state?.isInitialized && client.funnel?.getState()?.isInitialized) return client;
      await new Promise(resolve => setTimeout(resolve, 100));
    } while (Date.now() < deadline);
    throw new Error('The custom checkout has not loaded. Please try again.');
  };
  const signature = cart => JSON.stringify(cart.items.map(item => [item.key, item.quantity]).sort());
  window.RastaWholesaleCheckout = {
    async open(cart, verify = async () => cart) {
      const client = await waitForClient();
      cart = await verify();
      if (cart.currency !== 'ZAR' || !cart.token || !cart.items?.length) throw new Error('We could not verify your wholesale order for the custom checkout.');
      if (cart.items.some(item => !window.RastaWholesaleSession.ownsLine(item) || item.gift_card || item.selling_plan_allocation || String(item.properties?._cs_free_gift || '').toLowerCase() === 'true')) throw new Error('Only wholesale portal products can continue to this checkout.');
      const checkoutInit = {
        cartToken: cart.token,
        lineItems: cart.items.map(item => ({ externalVariantId: String(item.variant_id), quantity: item.quantity, properties: item.properties })),
        customer: { currency: 'ZAR', locale: window.Shopify?.locale || document.documentElement.lang || 'en-ZA' },
        returnUrl: window.RastaWholesaleSession.returnUrl(),
        storeId: window.TgdMapper.storeId,
        metadata: { rastaWholesale: true },
        shopifyCartRaw: { ...cart, discount_codes: cart.discount_codes || [] },
      };
      const result = await client.funnel.navigate({ type: 'INIT_CHECKOUT', data: { checkoutInit } }, { autoRedirect: false, waitForSession: true });
      if (!result?.url) throw new Error('The custom checkout did not return a checkout link. Please try again.');
      const target = new URL(result.url);
      if (target.protocol !== 'https:' || target.hostname !== 'checkout.rastashop.co.za') throw new Error('The custom checkout returned an unexpected destination. Please contact the Rasta team.');
      if (result.checkoutToken) target.searchParams.set('checkoutToken', result.checkoutToken);
      const latest = await verify();
      if (signature(latest) !== signature(cart)) throw new Error('Your order changed while checkout was preparing. Review your order and try again.');
      window.RastaWholesaleSession.markCheckout(latest);
      // Preserve the portal in browser history; the generic mapper replaces it with the store home page.
      window.location.assign(target.href);
    },
  };
})();
